<template>
  <div class="hrms-staappr">
    <div class="header-paper clearfix">
       <div class="header-left">
        <div class="box-header-label" v-if="currentDtereqDisp">
          <div class="header-label-ico"><i class="fa fa-calendar"></i> {{labels['dtereq'][nowLang]}}</div>
          <div class="header-label-data">: {{ currentDtereq }}</div>
        </div>
        <div class="box-header-label" v-if="currentNumseqDisp">
          <div class="header-label-ico"><i class="fa fa-file-text"></i> {{labels['numseq'][nowLang]}}</div>
          <div class="header-label-data">: {{ currentNumseq }}</div>
        </div>  
        <div class="box-header-label" v-if="currentCodempidDisp">
          <div class="header-label-ico"><i class="fa fa-user"></i> {{labels['codempid'][nowLang]}}</div>
          <div class="header-label-data">: {{ currentCodempid }}</div>
        </div>
      </div>
      <div class="header-right">
        <div class="panel-step-staappr">
          <div class="staappr-label">{{ labels['status'][nowLang] }}</div>

          <div class="clearfix mobile-steps-staappr">
            <div class="step" :class="class_active_new">
              <div>
                <span class="circle"></span>
              </div>
              <div class="step-name">
                {{ labels['new'][nowLang] }}
              </div>
            </div>

            <div class="step" :class="class_active_p">
              <div>
                <span class="line"></span>
                <span class="circle"></span>
              </div>
              <div class="step-name">
                <template v-if="status == 'C'">
                  {{ labels['c'][nowLang] }}
                </template>
                <template v-else>
                  {{ labels['p'][nowLang] }}
                </template>
              </div>
            </div>

            <div class="step" :class="class_active_a">
              <div>
                <span class="line"></span>
                <span class="circle"></span>
              </div>
              <div class="step-name">
              {{ labels['a'][nowLang] }}
              </div>
            </div>

            <div class="step" :class="class_active_y">
              <div>
                <span class="line"></span>
                <span class="circle"></span>
              </div>
              <div class="step-name">
                <template v-if="status == 'N'">
                  {{ labels['n'][nowLang] }}
                </template>
                <template v-else>
                  {{ labels['y'][nowLang] }}
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>    
    </div>
  </div>
</template>

<script>
export default {
  name: 'hrms-staappr',
  data () {
    return {
      status: '',
      class_active_new: '',
      class_active_p: '',
      class_active_a: '',
      class_active_y: '',
      labels: {
        'dtereq': {'en': 'Request Date', 'th': 'วันที่ขอ'},
        'numseq': {'en': 'Sequence No.', 'th': 'ลำดับที่'},
        'codempid': {'en': 'Employee Code', 'th': 'รหัสพนักงาน'},
        'status': {'en': 'Request Status', 'th': 'สถานะคำร้อง'},
        'new': {'en': 'New', 'th': 'คำร้องใหม่'},
        'p': {'en': 'Pending', 'th': 'รอพิจารณา'},
        'a': {'en': 'Approving', 'th': 'อยู่ระหว่างการอนุมัติ'},
        'a2': {'en': 'During Process', 'th': 'ระหว่างดำเนินการ'},
        'n': {'en': 'Refused', 'th': 'ไม่อนุมัติ'},
        'y': {'en': 'Approved', 'th': 'อนุมัติแล้ว'},
        'c': {'en': 'Canceled', 'th': 'ยกเลิก'},
        's': {'en': 'Settled', 'th': 'จบ'}
      }
    }
  },
  props: {
    staappr: {
      type: String
    },
    nowLang: {
      type: String
    },
    currentDtereq: {
      type: String
    },
    currentNumseq: {
      type: String
    },
    currentCodempid: {
      type: String
    },
    currentDtereqDisp: {
      type: Boolean,
      default: true
    },
    currentNumseqDisp: {
      type: Boolean,
      default: true
    },
    currentCodempidDisp: {
      type: Boolean,
      default: true
    }
  },
  created () {
    if (typeof this.staappr !== 'undefined') {
      this.status = this.staappr.toUpperCase()
    }
    this.status = (this.status === 'P' || this.status === 'C' || this.status === 'A' || this.status === 'Y' || this.status === 'N') ? this.status : 'NEW'
  },
  watch: {
    staappr () {
      if (typeof this.staappr !== 'undefined') {
        this.status = this.staappr.toUpperCase()
      }
      this.status = (this.status === 'P' || this.status === 'C' || this.status === 'A' || this.status === 'Y' || this.status === 'N') ? this.status : 'NEW'
      this.class_active_new = ''
      this.class_active_p = ''
      this.class_active_a = ''
      this.class_active_y = ''
      if (this.status === 'NEW') {
        this.class_active_new = 'active'
      } else if (this.status === 'P' || this.status === 'C') {
        this.class_active_new = 'active'
        this.class_active_p = 'active ' + (this.status).toLowerCase()
      } else if (this.status === 'A') {
        this.class_active_new = 'active'
        this.class_active_p = 'active'
        this.class_active_a = 'active'
      } else if (this.status === 'Y' || this.status === 'N') {
        this.class_active_new = 'active'
        this.class_active_p = 'active'
        this.class_active_a = 'active'
        this.class_active_y = 'active ' + (this.status).toLowerCase()
      }
    },
    status () {
      if (typeof this.staappr !== 'undefined') {
        this.status = this.staappr.toUpperCase()
      }
      this.status = (this.status === 'P' || this.status === 'C' || this.status === 'A' || this.status === 'Y' || this.status === 'N') ? this.status : 'NEW'
      this.class_active_new = ''
      this.class_active_p = ''
      this.class_active_a = ''
      this.class_active_y = ''
      if (this.status === 'NEW') {
        this.class_active_new = 'active'
      } else if (this.status === 'P' || this.status === 'C') {
        this.class_active_new = 'active'
        this.class_active_p = 'active ' + (this.status).toLowerCase()
      } else if (this.status === 'A') {
        this.class_active_new = 'active'
        this.class_active_p = 'active'
        this.class_active_a = 'active'
      } else if (this.status === 'Y' || this.status === 'N') {
        this.class_active_new = 'active'
        this.class_active_p = 'active'
        this.class_active_a = 'active'
        this.class_active_y = 'active ' + (this.status).toLowerCase()
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// component.vue?6eafb840